import { useCallback, useEffect } from "preact/hooks";
import useAxios from "../../hooks/useAxios";


export default function useService(service_name) {

    const { data: serviceInfo, fetch } = useAxios();

    const fetchServiceInfo = useCallback((config) => {
        const targetUrl = `/user/reports/overview/${service_name}`;
        const requestParams = { method: "GET", ...config };
        return fetch(targetUrl, requestParams);
    }, [service_name]);

    useEffect(() => fetch(`/user/reports/overview/${service_name}`, {
        method: "GET",
        params: {
            date_from: parseInt(new Date(
                new Date().getFullYear(),
                new Date().getMonth(), 1).getTime() / 1000
            ),
            date_to: parseInt(new Date(
                new Date().getFullYear(),
                new Date().getMonth() + 1, 0, 23, 59, 59).getTime() / 1000
            )
        }
    }), []);

    return { serviceInfo, fetchServiceInfo };
}